<template>
    <div class="content-section albums-section container-fluid md-up">
        <div class="row section-nav-row">
            <div class="col pl-0 pr-0">
                <section-nav-no-menu navTitle="Novedades Discográficas" />
            </div>
        </div>
        <div class="row grid-row">
            <div class="col-12 col-md-9 albums">
                <albums-grid :albumList="albumList"/>
                <AlbumsCTA />
            </div>
            <div class="col-12 col-md-3">
                <printed-vertical :printedList="printedList" />
            </div>
        </div>
    </div>
    <div class="content-section container-fluid mobile-albums-printed sm-only">
        <horizontal-carousel :contentList="albumsFullList" componentName="album-small-box" class="horizontal-carousel-albums sm-only"/>
        <h3 class="mobile-printed-title sm-only">Ediciones Impresas</h3>
        <horizontal-carousel :contentList="printedFullList" componentName="printed-small-box" class="horizontal-carousel-printed sm-only"/>
    </div>
</template>

<script>
import { ref } from 'vue'
import store from '../store/store.js';
import AlbumsAPI from '../classes/AlbumsAPI'
import AlbumsCTA from './AlbumsCTA.vue';
import AlbumsGrid from './AlbumsGrid.vue'
import PrintedVertical from './PrintedVertical.vue';
import SectionNavNoMenu from './SectionNavNoMenu.vue';
import HorizontalCarousel from './HorizontalCarousel.vue';

import IssuesAPI from '../classes/IssuesAPI';

export default {
  components: { AlbumsGrid, SectionNavNoMenu, PrintedVertical, AlbumsCTA, HorizontalCarousel },
  setup() {
        const issuesAPI = new IssuesAPI(); // Agrega esta línea
        const printedFullList = ref([]); // Cambia a reactive
        
        // Llama a la API para obtener las ediciones
        issuesAPI.getIssues((data) => {
            printedFullList.value = data.data.map(issue => ({
            id: issue.issue_id,
            title: issue.issue_title,
            description: issue.issue_month,
            imgUrl: issue.issue_cover_url,
            issue_link_url: issue.issue_link_url
            }));

            store.printedEdsCarousel.setNumPages(printedFullList.value.length);
        });
        const albumsAPI = new AlbumsAPI();
        var albumsFullList = ref([]);
        albumsAPI.getPosts(40, 0, (data)=> {
                albumsFullList.value = Object.entries(albumsFullList.value).map(entry => entry[1]).concat(Object.entries(data.data.posts).map(entry => entry[1]));
                store.albumsCarousel.setNumPages(Object.entries(albumsFullList.value).length);
                });
        store.albumsCarousel.setNumPages(albumsFullList.value.length);
        
      return { albumsFullList, printedFullList };
  },
  computed: {
      albumList() {
          return store.albumsCarousel.getCurrentPageList(this.albumsFullList);
      },
      printedList() {
          return store.printedEdsCarousel.getCurrentPageList(this.printedFullList);
      }
  }
    
}
</script>

<style lang="scss" scoped>
    .horizontal-carousel-printed {
        margin-top: 30px;
    }
    .mobile-printed-title {
        margin-top: 20px;
    }
</style>